export const calculateSum = (array, property) => {
  let sum = 0;

  array.forEach(element => {
    sum += element[property];
  });

  return sum;
}